import { useState } from 'react'
import Link from 'next/link'
import Image from 'next/future/image'
import { Carousel, Picture } from '@smuchile/pkg-unimarc-components'
import {
  addToHomeData,
  clickedPromos,
  trigger,
  triggerLoginEvent,
  useSession,
  visiblePromos
} from '@smuchile/pkg-unimarc-hooks'
import { MEMBERSHIP_ID } from '@smuchile/pkg-unimarc-hooks/shared/constants'

export interface IShowCaseWebProps {
  data: object[]
  cfIndex?: number
  isMobile: boolean
  salesChannel: string
}

export const ShowCaseWeb = ({
  data,
  cfIndex,
  isMobile,
  salesChannel
}: IShowCaseWebProps) => {
  const { isLoading, isLoggedIn } = useSession()

  const [autoPlay, setAutoPlay] = useState(true)
  const contentObject = isMobile ? 'imageMobile' : 'imageDesktop'
  const containerProps = { maxWidth: '1120px', minHeight: '450px' }

  const handleRedirect = async (promosData) => {
    const { reference, promotionId, promotionName } = promosData

    if (reference && promotionId && promotionName) {
      sessionStorage.setItem(
        reference,
        JSON.stringify({
          promotionId: promotionId,
          promotionName: promotionName
        })
      )
    }

    if (promosData?.promotionId === MEMBERSHIP_ID.BANNER_HOME) {
      if (!isLoading && isLoggedIn) {
        trigger({ eventType: 'openMembershipModal' })
      } else {
        triggerLoginEvent({ eventType: 'loginModal', data: { show: true } })
      }
    }

    clickedPromos(promosData)
  }

  const handleStart = () => {
    return setAutoPlay(false)
  }

  const handleEnd = () => {
    return setAutoPlay(true)
  }

  return (
    <>
      <Carousel
        afterChange={() => {
          return visiblePromos({})
        }}
        arrows={!isMobile}
        autoPlay={autoPlay}
        containerProps={containerProps}
        deviceType={isMobile ? 'mobile' : 'desktop'}
        focusOnSelect
        infinite
        opacityArrows
        pauseOnHover
        showDots
        ssr
      >
        {data?.length > 0 &&
          data.map((item, index) => {
            const itemSaleChannels = item['fields']['saleChannels']
            const promoData = {
              ...item,
              locationId: `${cfIndex} - ${index + 1}`
            }
            const mobilePadding = isMobile ? '0 12px' : '0'

            if (
              itemSaleChannels?.includes(salesChannel) ||
              itemSaleChannels === undefined
            ) {
              return (
                <Picture
                  alt={item['alt']}
                  anchor
                  catchImgRef={(ref) => {
                    addToHomeData({ ref, promoData })
                  }}
                  height='100%'
                  key={item['label']}
                  linkWrapper={Link}
                  nextImage={Image}
                  onClick={() => {
                    handleRedirect(promoData)
                  }}
                  onTouchEnd={handleEnd}
                  onTouchStart={handleStart}
                  priority={index === 0}
                  src={item[contentObject]?.fields?.file?.url}
                  style={{
                    cursor: 'pointer',
                    height: '100%',
                    width: '100%',
                    padding: mobilePadding
                  }}
                  title={item[contentObject]?.fields?.title}
                  url={item['reference']}
                  width='100%'
                />
              )
            }
            return null
          })}
      </Carousel>
    </>
  )
}
